/*
 * @Author: your name
 * @Date: 2022-04-06 20:16:12
 * @LastEditTime: 2022-04-06 20:21:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kaiba_admin\src\hooks\use-modal.js
 */
import { ref, reactive } from 'vue'

/**
 *
 * @param {object} params
 * @param {boolean} params.visible
 * @returns
 */
export function useModal(params = { visible: false }) {
    const visible = ref(params.visible)

    const setVisible = (status) => {
        visible.value = status
    }

    const toggle = () => {
        visible.value = !visible.value
    }

    const showModal = () => {
        setVisible(true)
    }

    const handleCancel = () => {
        setVisible(false)
    }

    const handleOK = () => {
        setVisible(false)
    }

    return reactive({
        visible,
        toggle,
        setVisible,
        showModal,
        handleCancel,
        handleOK,
    })
}
